import { NotificationEndpoints } from '../types/Endpoints';

import { RequestService } from 'itaf';

const extraHeaders = {
  'x-app': 'notification',
  'X-CSRF': 'b68e3854-c5cf-4676-8263-5b5bce065a60',
};

class NotificationService {
  markReadNote(id) {
    const API_URL = NotificationEndpoints.NOTIFICATION;
    return RequestService.putRequest(`${API_URL}/${id}/read`, {}, {}, extraHeaders);
  }
  
  menuNotification(note) {
    const API_URL = NotificationEndpoints.NOTIFICATION;
    return RequestService.postRequest(`${API_URL}/menu`, note, {}, extraHeaders);
  }
  
  userNotifications(userId, page) {
    const API_URL = NotificationEndpoints.NOTIFICATION;
    return RequestService.getPageableRequest(`${API_URL}/user`, page, {}, extraHeaders);
  }
}

export default new NotificationService();
